import { axiosRequest } from '@/util/axios-request';

// 批量发送，是否提示批量发送弹框
export var batchNotic = function batchNotic(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/isShowBatchSendCombineNotice',
    method: 'POST',
    data: data
  });
};

// 保存-批量发送工资条
export var saveBatchSend = function saveBatchSend(data) {
  return axiosRequest({
    url: '/web/payslip/saveBatchSend',
    method: 'POST',
    data: data
  });
};

// 创建模版时获取模版详情
export var getAllColumns = function getAllColumns(data) {
  return axiosRequest({
    url: '/web/payslip/getAllColumns',
    method: 'GET',
    params: data
  });
};

// 获取已有的模版详情
export var getSchemeInfo = function getSchemeInfo(data) {
  return axiosRequest({
    url: '/web/payslip/getSchemeInfo',
    method: 'GET',
    params: data
  });
};

// 保存新建工资条模板
export var addscheme = function addscheme(data) {
  return axiosRequest({
    url: '/web/payslip/addscheme',
    method: 'POST',
    data: data
  });
};

// 保存编辑工资条模板
export var editScheme = function editScheme(data) {
  return axiosRequest({
    url: '/web/payslip/editScheme',
    method: 'POST',
    data: data
  });
};

// 获取模版列表
export var getSchemeList = function getSchemeList(data) {
  return axiosRequest({
    url: '/web/payslip/getSchemeList',
    method: 'GET',
    params: data
  });
};

// 工资条模版 删除
export var deleteScheme = function deleteScheme(data) {
  return axiosRequest({
    url: '/web/payslip/deleteScheme',
    method: 'POST',
    data: data
  });
};

// 获取结算类型
export var getTypeAndTaxList = function getTypeAndTaxList() {
  return axiosRequest({
    url: '/web/payslip/getTypeAndTaxList',
    method: 'GET'
  });
};

// 待发送的子项目list
export var awaitsendlist = function awaitsendlist(data) {
  return axiosRequest({
    url: '/web/payslip/awaitsendlist',
    method: 'GET',
    params: data
  });
};

// 待发送的子项目list
export var getSendAllColumns = function getSendAllColumns(data) {
  return axiosRequest({
    url: '/web/payslip/getSendAllColumns',
    method: 'GET',
    params: data
  });
};

// 待发送的子项目list
export var getSchemeListBySubId = function getSchemeListBySubId(data) {
  return axiosRequest({
    url: '/web/payslip/getSchemeListBySubId',
    method: 'GET',
    params: data
  });
};

// 发送工资条
export var sendPayslip = function sendPayslip(data) {
  return axiosRequest({
    url: '/web/payslip/sendPayslip',
    method: 'POST',
    data: data
  });
};

// 已经发送-工资条的pay_month list
export var getSentPayMonth = function getSentPayMonth(data) {
  return axiosRequest({
    url: '/web/payslip/sentPayMonthList',
    method: 'GET',
    params: data
  });
};

// 已经发送-工资条的list
export var getSentList = function getSentList(data) {
  return axiosRequest({
    url: '/web/payslip/sentList',
    method: 'GET',
    params: data
  });
};

// 待发子项目选择工资条
export var recallSent = function recallSent(data) {
  return axiosRequest({
    url: '/web/payslip/recallSent',
    method: 'POST',
    data: data
  });
};

// 待发子项目取消定时任务
export var cancelTimedSend = function cancelTimedSend(data) {
  return axiosRequest({
    url: '/web/payslip/cancelTimedSend',
    method: 'POST',
    data: data
  });
};

// 已经发送-工资条设置
export var sentPayslipSetting = function sentPayslipSetting(data) {
  return axiosRequest({
    url: '/web/payslip/sentPayslipSetting',
    method: 'GET',
    params: data
  });
};

// 已经发送-payslip info
export var sentPayslipInfo = function sentPayslipInfo(data) {
  return axiosRequest({
    url: '/web/payslip/sentPayslipInfo',
    method: 'GET',
    params: data
  });
};

// 已经发送-错误重发
export var afreshSendErrStaff = function afreshSendErrStaff(data) {
  return axiosRequest({
    url: '/web/payslip/afreshSendErrStaff',
    method: 'GET',
    params: data
  });
};

// 已经发送-payslip info
export var sentPayslipStaffList = function sentPayslipStaffList(data) {
  return axiosRequest({
    url: '/web/payslip/sentPayslipStaffList',
    method: 'GET',
    params: data
  });
};

// 发送工资条 错误重发 状态
export var getAfreshSendStatus = function getAfreshSendStatus(data) {
  return axiosRequest({
    url: '/web/payslip/getAfreshSendStatus',
    method: 'GET',
    params: data
  });
};

// 发送工资条 获取发送状态
export var getPayslipSentState = function getPayslipSentState(data) {
  return axiosRequest({
    url: '/web/payslip/getPayslipSentState',
    method: 'GET',
    params: data
  });
};

// 验证工资条姓名是否可用
export var validateSchemeName = function validateSchemeName(data) {
  return axiosRequest({
    url: '/web/payslip/validateSchemeName',
    method: 'POST',
    data: data
  });
};

// 工资条模版pdf
export var previewSchemePdf = function previewSchemePdf(data) {
  return axiosRequest({
    url: '/web/payslip/previewSchemePdf',
    method: 'POST',
    data: data
  });
};

// 员工过往工资条列表查询
export var downloadPayslipList = function downloadPayslipList(data) {
  return axiosRequest({
    url: '/web/payslip/downloadPayslipList',
    method: 'GET',
    params: data
  });
};

// 下载工资条 发送邮箱
export var sendPdfToEmail = function sendPdfToEmail(data) {
  return axiosRequest({
    url: '/web/payslip/sendPdfToEmail',
    method: 'POST',
    data: data
  });
};

// 下载工资条
export var downloadPdf = function downloadPdf(data) {
  return axiosRequest({
    url: '/web/payslip/downloadPdf',
    method: 'POST',
    data: data
  });
};

// 全部下载工资条
export var downloadPayslipZip = function downloadPayslipZip(data) {
  return axiosRequest({
    url: '/web/payslip/downloadPayslipZip',
    method: 'get',
    params: data
  });
};

// 工资条安全配置枚举项
export var payslipConfigInit = function payslipConfigInit(data) {
  return axiosRequest({
    url: '/web/payslip/payslipConfigInit',
    method: 'get',
    params: data
  });
};

// 获取工资条安全配置
export var getPayslipConfig = function getPayslipConfig(data) {
  return axiosRequest({
    url: '/web/payslip/getPayslipConfig',
    method: 'get',
    params: data
  });
};

// 保存工资条安全配置
export var savePayslipConfig = function savePayslipConfig(data) {
  return axiosRequest({
    url: '/web/payslip/savePayslipConfig',
    method: 'get',
    params: data
  });
};

// 获取工资条安全配置修改记录
export var getPayslipConfigLog = function getPayslipConfigLog(data) {
  return axiosRequest({
    url: '/web/payslip/getPayslipConfigLog',
    method: 'get',
    params: data
  });
};
//   /app/payslip/getPayslipConfigLog